import { AUTO_GENERATED_QUESTIONS } from "@/lib/auto-generated-questions";
import type { LicenseAnswers } from "@/types/license";

interface FeeAnswerQuestion {
  id: string;
  question: string;
  answer_type: string;
}

export interface FeeAnswerOverrides {
  propertyStructureAnswer?: string;
  commercialManagedPropertyAnswer?: boolean;
  numberOfUnitsAnswer?: number;
  vacancyAnswer?: boolean;
}

function findQuestionAnswer(
  questions: FeeAnswerQuestion[],
  questionText: string,
  answerType: string,
  licenseAnswers: LicenseAnswers,
): unknown {
  const question = questions.find(
    (item) =>
      item.question.trim().toLowerCase() ===
        questionText.trim().toLowerCase() && item.answer_type === answerType,
  );
  if (!question) {
    return undefined;
  }
  return licenseAnswers[question.id];
}

export function extractFeeAnswerOverrides(
  questions: FeeAnswerQuestion[] | undefined,
  licenseAnswers: LicenseAnswers | null | undefined,
): FeeAnswerOverrides {
  if (!questions || !licenseAnswers) {
    return {};
  }

  const propertyStructure = findQuestionAnswer(
    questions,
    AUTO_GENERATED_QUESTIONS.property_structure.text,
    "single_select",
    licenseAnswers,
  );
  const commercialManagedProperty = findQuestionAnswer(
    questions,
    AUTO_GENERATED_QUESTIONS.commercial_managed_property.text,
    "boolean",
    licenseAnswers,
  );
  const numberOfUnits = findQuestionAnswer(
    questions,
    AUTO_GENERATED_QUESTIONS.number_of_units.text,
    "number",
    licenseAnswers,
  );
  const vacancy = findQuestionAnswer(
    questions,
    AUTO_GENERATED_QUESTIONS.vacancy.text,
    "boolean",
    licenseAnswers,
  );

  let numberOfUnitsAnswer: number | undefined;
  if (typeof numberOfUnits === "number") {
    numberOfUnitsAnswer = numberOfUnits;
  } else if (typeof numberOfUnits === "string" && numberOfUnits.trim() !== "") {
    const parsed = Number(numberOfUnits);
    numberOfUnitsAnswer = Number.isNaN(parsed) ? undefined : parsed;
  }

  return {
    propertyStructureAnswer:
      typeof propertyStructure === "string" ? propertyStructure : undefined,
    commercialManagedPropertyAnswer:
      typeof commercialManagedProperty === "boolean"
        ? commercialManagedProperty
        : undefined,
    numberOfUnitsAnswer,
    vacancyAnswer: typeof vacancy === "boolean" ? vacancy : undefined,
  };
}
